// ============================================================================
// File: components/tables/PendingActionsTable.jsx
// Purpose:
//   Enterprise Pending Actions Content (NO CARD WRAPPER)
// ============================================================================

import React from "react";

export default function PendingActionsTable({ data }) {

  if (!data || data.length === 0) {
    return (
      <div className="empty-actions">
        ✅ No pending actions
      </div>
    );
  }

  // -------------------------------------------------------
  // AGE COLOR LOGIC
  // -------------------------------------------------------
  const getAgeClass = (days) => {
    if (days >= 7) return "action-high";
    if (days >= 3) return "action-medium";
    return "action-low";
  };

  return (
    <div className="actions-list">

      {data.slice(0, 8).map((item, index) => (
        <div
          key={index}
          className={`action-row ${getAgeClass(item.age_days)}`}
        >

          {/* MODULE */}
          <div className="action-module">
            {item.module}
          </div>

          {/* DOCUMENT NUMBER */}
          <div className="action-doc">
            {item.document_no}
          </div>

          {/* CURRENT STATUS */}
          <div className="action-status">
            {item.status}
          </div>

          {/* NEXT ACTION */}
          <div className="action-next">
            👉 {item.action}
          </div>

          {/* AGE */}
          <div className="action-right">
            {item.age_days} days
          </div>

        </div>
      ))}

    </div>
  );
}
